import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { getStyle, SERVICE_CHAIN } from '../../../utils/utils';
import CBMediaQuery from '../../shared/CBMediaQuery';
import CBSubHeading from '../../shared/CBSubHeading';
import {
  fetchAssetCategories as _fetchAssetCategories,
  createAssetCategory as _createAssetCategory,
  updateAssetCategory as _updateAssetCategory,
  deleteAssetCategory as _deleteAssetCategory,
} from '../../../actions/assetCategoryActions';
import AssetCategoryRow from './AssetCategoryRow';

// Ajoneuvo-/laitetyypit of an organization (nosturi, trukki, ...). Works like
// SettingsBusinessUnits: fleet portal settings, and embedded in the chain
// portal with the customer's `organizationId`.
class SettingsAssetCategories extends React.Component {
  componentDidMount() {
    this.fetchCategories();
  }

  componentDidUpdate(prevProps) {
    if (this.getOrganizationId(prevProps) !== this.getOrganizationId()) {
      this.fetchCategories();
    }
  }

  getOrganizationId = (props) => {
    const p = props || this.props;
    return p.organizationId || p.selectedOrganizationId;
  };

  getService = () => this.props.service || this.props.appService;

  fetchCategories = () => {
    const organizationId = this.getOrganizationId();
    if (organizationId && organizationId !== 'all') {
      this.props.fetchAssetCategories(organizationId);
    }
  };

  getUserRole = () => {
    const { user } = this.props;
    const organizationId = this.getOrganizationId();
    if (!user || !user.organizations || !organizationId) return null;
    const organization = user.organizations.find((org) => org.id == organizationId);
    return organization ? organization.user_role : null;
  };

  canEdit = () => {
    const { user } = this.props;
    if (user && user.is_staff) return true;
    // The chain route is already admin/manager-gated.
    if (this.getService() === SERVICE_CHAIN) return true;
    const role = this.getUserRole();
    return role === 'admin' || role === 'manager';
  };

  render() {
    const {
      t, assetCategories, createAssetCategory, updateAssetCategory, deleteAssetCategory, embedded,
    } = this.props;
    const organizationId = this.getOrganizationId();
    const canEdit = this.canEdit();

    if (!organizationId || organizationId === 'all') {
      return null;
    }

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, embedded ? 'embeddedContainer' : 'container')}>
            <div style={getStyle(screenSize, styles, 'sectionContainer')}>
              <CBSubHeading>{t('heading')}</CBSubHeading>
            </div>
            <div style={getStyle(screenSize, styles, 'sectionContainer')}>
              <p>{t('description')}</p>
            </div>
            <div style={{ overflowX: 'auto' }}>
              <table>
                <thead>
                  <tr>
                    <th style={getStyle(screenSize, styles, 'tableHeading')}>{t('nameLabel')}</th>
                    <th style={getStyle(screenSize, styles, 'tableHeading')} />
                  </tr>
                </thead>
                <tbody>
                  {assetCategories.map((category) => (
                    <AssetCategoryRow
                      key={category.id}
                      assetCategory={category}
                      organizationId={organizationId}
                      canEdit={canEdit}
                      createAssetCategory={createAssetCategory}
                      updateAssetCategory={updateAssetCategory}
                      deleteAssetCategory={deleteAssetCategory}
                    />
                  ))}
                  {!assetCategories.length && (
                    <tr>
                      <td style={getStyle(screenSize, styles, 'emptyCell')} colSpan={2}>{t('noAssetCategories')}</td>
                    </tr>
                  )}
                  {canEdit && (
                    <AssetCategoryRow
                      isNew
                      organizationId={organizationId}
                      canEdit
                      createAssetCategory={createAssetCategory}
                      updateAssetCategory={updateAssetCategory}
                      deleteAssetCategory={deleteAssetCategory}
                    />
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    container: {
      padding: 32,
      display: 'flex',
      flexDirection: 'column',
    },
    embeddedContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
    sectionContainer: {
      marginBottom: 16,
    },
    tableHeading: {
      fontFamily: 'TitilliumWeb-Regular',
      fontSize: 12,
      color: '#ffffff',
      paddingLeft: 8,
      paddingBottom: 8,
      textAlign: 'left',
    },
    emptyCell: {
      color: 'rgba(255, 255, 255, 0.7)',
      padding: 8,
      fontSize: 14,
    },
  },
  medium: {
    container: {
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
    },
  },
};

function mapStateToProps(state) {
  return {
    user: state.authUser.user,
    appService: state.app.service,
    selectedOrganizationId: state.organization.selectedOrganization,
    assetCategories: state.assetCategory.assetCategories,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchAssetCategories: _fetchAssetCategories,
    createAssetCategory: _createAssetCategory,
    updateAssetCategory: _updateAssetCategory,
    deleteAssetCategory: _deleteAssetCategory,
  },
)(translate('AssetCategories')(SettingsAssetCategories));
